<template>
    <button
        @click="copy"
        class="inline-flex justify-center items-center my-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:outline-none w-full"
    >
        <component
            :is="success ? CheckCircleIcon : DuplicateIcon"
            class="h-6 w-6 mr-2"
        />
        {{ success ? "Copied" : "Copy Link" }}
    </button>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { copyText } from "vue3-clipboard";
import { DuplicateIcon } from "@heroicons/vue/outline";
import { CheckCircleIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    link?: string;
}>();

const success = ref(false);

function copy() {
    copyText(props.link, undefined, (error: any) => {
        if (!error) {
            success.value = true;
        }
    });
}
</script>
